const getters = {
  searchResult: state => {
    return state.searchResult
  },
  loading: state => {
    return state.loading
  },
  sortOptions: state => {
    return state.sortOptions
  },
  filter: state => {
    return state.filter
  },
  page: state => {
    return state.page
  },
}

export default getters
